var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSentellentLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2331 8.89095L23.6291 1.32048L23.8875 1.09509L30.4915 8.66556L30.2331 8.89095Z",
    fill: "#1C3754"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1973 4.75432L4.64027 13.6939L4.54102 13.3657L34.0981 4.42615L34.1973 4.75432Z",
    fill: "#4586D5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8724 27.2216C22.8724 27.8443 22.3676 28.3491 21.7449 28.3491C21.1222 28.3491 20.6174 27.8443 20.6174 27.2216C20.6174 26.5989 21.1222 26.0941 21.7449 26.0941C22.3676 26.0941 22.8724 26.5989 22.8724 27.2216Z",
    fill: "#2A5782"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0474 27.8662C13.0474 28.4889 12.5426 28.9937 11.9199 28.9937C11.2972 28.9937 10.7924 28.4889 10.7924 27.8662C10.7924 27.2435 11.2972 26.7386 11.9199 26.7386C12.5426 26.7386 13.0474 27.2435 13.0474 27.8662Z",
    fill: "#4586D5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8454 10.1475C18.8454 10.6812 18.4127 11.1139 17.8789 11.1139C17.3452 11.1139 16.9125 10.6812 16.9125 10.1475C16.9125 9.61372 17.3452 9.18103 17.8789 9.18103C18.4127 9.18103 18.8454 9.61372 18.8454 10.1475Z",
    fill: "#2A5782"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4833 7.89283C24.4833 8.42659 24.0506 8.85928 23.5169 8.85928C22.9831 8.85928 22.5504 8.42659 22.5504 7.89283C22.5504 7.35908 22.9831 6.92639 23.5169 6.92639C24.0506 6.92639 24.4833 7.35908 24.4833 7.89283Z",
    fill: "#417FC1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4364 4.34913C35.4364 4.70496 35.148 4.99342 34.7921 4.99342C34.4363 4.99342 34.1478 4.70496 34.1478 4.34913C34.1478 3.99329 34.4363 3.70483 34.7921 3.70483C35.148 3.70483 35.4364 3.99329 35.4364 4.34913Z",
    fill: "#3F84CD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1408 5.6377C39.1408 5.99354 38.8523 6.282 38.4965 6.282C38.1406 6.282 37.8522 5.99354 37.8522 5.6377C37.8522 5.28187 38.1406 4.99341 38.4965 4.99341C38.8523 4.99341 39.1408 5.28187 39.1408 5.6377Z",
    fill: "#1A344F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1613 0.644295C24.1613 1.00013 23.8728 1.28859 23.517 1.28859C23.1611 1.28859 22.8727 1.00013 22.8727 0.644295C22.8727 0.288461 23.1611 0 23.517 0C23.8728 0 24.1613 0.288461 24.1613 0.644295Z",
    fill: "#1B3653"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3019 3.38294C15.3019 3.73878 15.0134 4.02724 14.6576 4.02724C14.3018 4.02724 14.0133 3.73878 14.0133 3.38294C14.0133 3.02711 14.3018 2.73865 14.6576 2.73865C15.0134 2.73865 15.3019 3.02711 15.3019 3.38294Z",
    fill: "#4588D6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24819 8.21461C7.24819 8.57044 6.95972 8.8589 6.60389 8.8589C6.24806 8.8589 5.95959 8.57044 5.95959 8.21461C5.95959 7.85877 6.24806 7.57031 6.60389 7.57031C6.95972 7.57031 7.24819 7.85877 7.24819 8.21461Z",
    fill: "#1B354E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.51009 13.6914C4.51009 14.0472 4.22163 14.3357 3.86579 14.3357C3.50996 14.3357 3.2215 14.0472 3.2215 13.6914C3.2215 13.3356 3.50996 13.0471 3.86579 13.0471C4.22163 13.0471 4.51009 13.3356 4.51009 13.6914Z",
    fill: "#4487D6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28859 21.9056C1.28859 22.2615 1.00013 22.5499 0.644295 22.5499C0.288461 22.5499 0 22.2615 0 21.9056C0 21.5498 0.288461 21.2614 0.644295 21.2614C1.00013 21.2614 1.28859 21.5498 1.28859 21.9056Z",
    fill: "#264B72"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4362 17.235C11.4362 17.7687 11.0035 18.2014 10.4697 18.2014C9.93599 18.2014 9.5033 17.7687 9.5033 17.235C9.5033 16.7012 9.93599 16.2686 10.4697 16.2686C11.0035 16.2686 11.4362 16.7012 11.4362 17.235Z",
    fill: "#417FC1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18154 30.6038C9.18154 31.1375 8.74885 31.5702 8.2151 31.5702C7.68135 31.5702 7.24866 31.1375 7.24866 30.6038C7.24866 30.07 7.68135 29.6373 8.2151 29.6373C8.74885 29.6373 9.18154 30.07 9.18154 30.6038Z",
    fill: "#264B72"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.027 31.5706C4.027 32.1043 3.59431 32.537 3.06056 32.537C2.52681 32.537 2.09412 32.1043 2.09412 31.5706C2.09412 31.0368 2.52681 30.6041 3.06056 30.6041C3.59431 30.6041 4.027 31.0368 4.027 31.5706Z",
    fill: "#4586D5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24819 39.6244C7.24819 39.9802 6.95972 40.2687 6.60389 40.2687C6.24806 40.2687 5.95959 39.9802 5.95959 39.6244C5.95959 39.2686 6.24806 38.9801 6.60389 38.9801C6.95972 38.9801 7.24819 39.2686 7.24819 39.6244Z",
    fill: "#264B72"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4298 44.2954C16.4298 44.6513 16.1414 44.9397 15.7855 44.9397C15.4297 44.9397 15.1412 44.6513 15.1412 44.2954C15.1412 43.9396 15.4297 43.6511 15.7855 43.6511C16.1414 43.6511 16.4298 43.9396 16.4298 44.2954Z",
    fill: "#4586D5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0604 47.3558C27.0604 47.7117 26.772 48.0001 26.4161 48.0001C26.0603 48.0001 25.7719 47.7117 25.7719 47.3558C25.7719 47 26.0603 46.7115 26.4161 46.7115C26.772 46.7115 27.0604 47 27.0604 47.3558Z",
    fill: "#4183CC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6982 36.1611C32.6982 36.6503 32.3016 37.047 31.8123 37.047C31.323 37.047 30.9264 36.6503 30.9264 36.1611C30.9264 35.6718 31.323 35.2751 31.8123 35.2751C32.3016 35.2751 32.6982 35.6718 32.6982 36.1611Z",
    fill: "#2E618E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1478 34.3892C34.1478 34.8785 33.7512 35.2751 33.2619 35.2751C32.7726 35.2751 32.376 34.8785 32.376 34.3892C32.376 33.8999 32.7726 33.5033 33.2619 33.5033C33.7512 33.5033 34.1478 33.8999 34.1478 34.3892Z",
    fill: "#417FC1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2348 40.51C41.2348 40.9103 40.9103 41.2348 40.51 41.2348C40.1097 41.2348 39.7852 40.9103 39.7852 40.51C39.7852 40.1097 40.1097 39.7852 40.51 39.7852C40.9103 39.7852 41.2348 40.1097 41.2348 40.51Z",
    fill: "#2E618E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7786 32.6174C44.7786 33.0177 44.4541 33.3422 44.0538 33.3422C43.6534 33.3422 43.3289 33.0177 43.3289 32.6174C43.3289 32.2171 43.6534 31.8926 44.0538 31.8926C44.4541 31.8926 44.7786 32.2171 44.7786 32.6174Z",
    fill: "#417FC1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8389 23.2752C47.8389 23.6756 47.5144 24.0001 47.1141 24.0001C46.7138 24.0001 46.3893 23.6756 46.3893 23.2752C46.3893 22.8749 46.7138 22.5504 47.1141 22.5504C47.5144 22.5504 47.8389 22.8749 47.8389 23.2752Z",
    fill: "#19314D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8925 9.58354C31.8925 10.0728 31.4959 10.4694 31.0066 10.4694C30.5174 10.4694 30.1207 10.0728 30.1207 9.58354C30.1207 9.09427 30.5174 8.69763 31.0066 8.69763C31.4959 8.69763 31.8925 9.09427 31.8925 9.58354Z",
    fill: "#2A5782"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1743 23.5975C38.1743 24.0867 37.7777 24.4834 37.2884 24.4834C36.7992 24.4834 36.4025 24.0867 36.4025 23.5975C36.4025 23.1082 36.7992 22.7115 37.2884 22.7115C37.7777 22.7115 38.1743 23.1082 38.1743 23.5975Z",
    fill: "#19314D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7252 13.0468C36.7252 13.5805 36.2926 14.0132 35.7588 14.0132C35.225 14.0132 34.7924 13.5805 34.7924 13.0468C34.7924 12.513 35.225 12.0803 35.7588 12.0803C36.2926 12.0803 36.7252 12.513 36.7252 13.0468Z",
    fill: "#417FC1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4957 17.8731L1.28094 21.7389L1.13495 21.4286L9.34971 17.5629L9.4957 17.8731Z",
    fill: "#295683"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.65183 20.7671L3.60988 30.6931L3.31702 30.5148L9.79151 19.8782L10.0592 18.1747L10.3979 18.2279L10.2594 19.1096L12.3372 15.696L12.63 15.8743L10.1197 19.9985L8.62609 29.5031L8.28739 29.4498L9.65183 20.7671Z",
    fill: "#386CA5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6682 26.641L12.7152 16.0101L13.0564 16.0437L12.0094 26.6746L11.6682 26.641ZM10.8539 28.5089L4.00824 31.1666L3.88416 30.847L10.7298 28.1893L10.8539 28.5089Z",
    fill: "#4586D5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.11929 38.9539L3.86426 32.2694L4.18913 32.1598L6.44416 38.8444L6.11929 38.9539Z",
    fill: "#1D3551"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.46106 30.818L0.803345 22.6032L1.12955 22.4977L3.78727 30.7124L3.46106 30.818Z",
    fill: "#17334E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.22253 31.8425L6.93394 39.0103L6.5965 38.9496L7.88509 31.7819L8.22253 31.8425Z",
    fill: "#254A6F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3311 39.5936L8.82776 31.4593L9.05071 31.1989L18.5541 39.3331L18.3311 39.5936Z",
    fill: "#295179"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4577 43.6128L11.753 29.0356L12.0853 28.9512L15.79 43.5284L15.4577 43.6128ZM15.0978 43.9313L3.82263 32.2534L4.06928 32.0153L15.3444 43.6931L15.0978 43.9313Z",
    fill: "#4586D5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5708 38.1283L12.4365 29.1082L12.6911 28.8785L20.8254 37.8987L20.5708 38.1283Z",
    fill: "#4586D5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6195 40.8426L7.32422 39.9567L7.33362 39.614L39.6289 40.4999L39.6195 40.8426Z",
    fill: "#1A3550"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9807 39.4235L16.4706 43.9335L16.2281 43.6911L20.7382 39.181L20.9807 39.4235Z",
    fill: "#4A9CD8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.28 44.7083L16.5082 44.5472L16.5122 44.2043L30.284 44.3654L30.28 44.7083Z",
    fill: "#326EAD"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8136 46.9146L19.6927 40.9549L19.9319 40.7092L26.0527 46.669L25.8136 46.9146Z",
    fill: "#193251"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7115 47.2745L7.10742 40.2678L7.22826 39.9469L25.8323 46.9536L25.7115 47.2745Z",
    fill: "#193251"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8604 40.9863L27.1356 47.1876L26.9854 46.8794L39.7102 40.6781L39.8604 40.9863Z",
    fill: "#193251"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2682 35.3926L31.4158 43.7685L31.0811 43.6944L32.9334 35.3186L33.2682 35.3926Z",
    fill: "#2E618E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.8952 36.5668L22.3582 39.1439L22.2592 38.8157L30.7961 36.2385L30.8952 36.5668Z",
    fill: "#396C9B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.786 40.501L32.5377 36.7158L32.6964 36.4119L39.9448 40.1971L39.786 40.501Z",
    fill: "#193251"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6048 33.3888L31.6048 44.2613L31.3746 44.0072L43.3746 33.1348L43.6048 33.3888Z",
    fill: "#3574A9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2468 33.888L40.9112 39.8478L40.592 39.7227L42.9276 33.7629L43.2468 33.888Z",
    fill: "#193251"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.8464 26.7695L21.7524 37.9641L21.4154 37.9011L23.5094 26.7064L23.8464 26.7695Z",
    fill: "#ECF3F5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4128 39.6742L8.82892 31.54L9.05078 31.2786L18.6347 39.4128L18.4128 39.6742Z",
    fill: "#1F4365"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5015 27.6285L9.22635 30.6889L9.13654 30.358L20.4117 27.2976L20.5015 27.6285Z",
    fill: "#5398D1"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.671 28.4646L19.4159 39.176L19.0804 39.1053L21.3355 28.3939L21.671 28.4646Z",
    fill: "#2B557E"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3545 34.8725L22.2068 38.5772L22.0892 38.2551L32.2369 34.5504L32.3545 34.8725Z",
    fill: "#4586D5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8123 39.9466C19.8123 40.3914 19.4517 40.752 19.0069 40.752C18.5621 40.752 18.2015 40.3914 18.2015 39.9466C18.2015 39.5018 18.5621 39.1412 19.0069 39.1412C19.4517 39.1412 19.8123 39.5018 19.8123 39.9466Z",
    fill: "#264B72"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2281 38.6575C22.2281 39.1023 21.8675 39.4629 21.4227 39.4629C20.9779 39.4629 20.6174 39.1023 20.6174 38.6575C20.6174 38.2127 20.9779 37.8522 21.4227 37.8522C21.8675 37.8522 22.2281 38.2127 22.2281 38.6575Z",
    fill: "#417FC1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4881 35.3205L22.5955 28.0722L22.8274 27.8197L30.72 35.068L30.4881 35.3205Z",
    fill: "#3C6A8C"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4439 23.9251L22.9942 27.2271L22.9125 26.8942L36.3621 23.5922L36.4439 23.9251Z",
    fill: "#3F84CD"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8129 21.4532L21.8331 37.8827L21.4957 37.8215L24.4756 21.392L24.8129 21.4532Z",
    fill: "#4586D5"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7127 33.6735L25.0617 21.1903L25.354 21.0111L33.005 33.4943L32.7127 33.6735Z",
    fill: "#3F84CD"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0432 24.5512L33.258 33.3297L32.9432 33.1939L36.7284 24.4154L37.0432 24.5512Z",
    fill: "#4982B2"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9 25.5273L25.6248 20.7757L25.758 20.4597L37.0331 25.2114L36.9 25.5273Z",
    fill: "#BDDCF0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.35768 30.0691L1.07581 22.4986L1.33966 22.2797L7.62153 29.8501L7.35768 30.0691Z",
    fill: "#193651"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7669 21.0051L13.0555 27.5286L12.8771 27.2358L23.5885 20.7123L23.7669 21.0051Z",
    fill: "#386CA5"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6663 26.4654L11.0824 18.1701L11.3068 17.9109L20.8907 26.2062L20.6663 26.4654Z",
    fill: "#386CA5"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.02367 14.5644L1.12434 21.3295L0.809204 21.1944L3.70853 14.4293L4.02367 14.5644Z",
    fill: "#17334E"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.88928 30.4342L3.69465 14.4879L4.03707 14.5052L3.2317 30.4515L2.88928 30.4342Z",
    fill: "#3F86D2"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.27701 9.17086L4.42467 13.2782L4.11212 13.1373L5.96447 9.02991L6.27701 9.17086Z",
    fill: "#1D3958"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2141 3.82688L4.6302 13.2497L4.38983 13.0052L13.9737 3.5824L14.2141 3.82688Z",
    fill: "#4FABF6"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0218 1.12298L7.47822 7.96862L7.34003 7.65484L22.8837 0.809204L23.0218 1.12298Z",
    fill: "#1E3A56"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.82881 16.4151L6.68787 8.92519L7.00405 8.7926L10.145 16.2825L9.82881 16.4151Z",
    fill: "#1A3652"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.758 9.99513L7.22107 8.62601L7.27536 8.28748L15.8123 9.6566L15.758 9.99513Z",
    fill: "#1E3A56"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1942 10.8337L11.315 16.6324L11.0742 16.3883L16.9534 10.5896L17.1942 10.8337Z",
    fill: "#295683"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0131 14.9797C14.0131 15.5135 13.5805 15.9462 13.0467 15.9462C12.513 15.9462 12.0803 15.5135 12.0803 14.9797C12.0803 14.446 12.513 14.0133 13.0467 14.0133C13.5805 14.0133 14.0131 14.446 14.0131 14.9797Z",
    fill: "#76DBDD"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5274 19.8881L13.9435 15.6196L14.083 15.3064L23.6669 19.5749L37.2751 25.3724L37.1407 25.6878L23.5274 19.8881Z",
    fill: "#2A5782"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3365 25.9716L17.8734 11.1529L18.2073 11.0748L21.6704 25.8936L21.3365 25.9716Z",
    fill: "#589DD7"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1937 33.0284L34.2541 34.3975L34.2022 34.0586L43.1418 32.6895L43.1937 33.0284ZM43.5244 33.5498L31.6855 44.2612L31.4554 44.007L43.2944 33.2955L43.5244 33.5498Z",
    fill: "#3574A9"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2753 44.2016L22.0605 39.3694L22.2344 39.0739L30.4491 43.9061L30.2753 44.2016Z",
    fill: "#51A1F8"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9762 15.0687L4.56677 14.0217L4.61474 13.6823L12.0241 14.7292L11.9762 15.0687Z",
    fill: "#4484C4"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6488 8.59692L14.0314 14.6372L13.8346 14.3564L22.452 8.31616L22.6488 8.59692Z",
    fill: "#4586D5"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3933 18.9453L23.2658 8.95875L23.6065 8.92029L24.734 18.9069L24.3933 18.9453Z",
    fill: "#4586D5"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7552 10.6314L25.9229 19.6515L25.6207 19.4896L30.4529 10.4695L30.7552 10.6314Z",
    fill: "#2A5782"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9672 13.7534L25.8665 19.7937L25.6769 19.508L34.7776 13.4678L34.9672 13.7534Z",
    fill: "#4586D5"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6478 22.7792L31.3324 10.4571L31.6472 10.3213L36.9626 22.6434L36.6478 22.7792Z",
    fill: "#326A9D"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2073 9.91625L18.9322 10.3189L18.9199 9.97629L30.1951 9.57361L30.2073 9.91625Z",
    fill: "#326A9D"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0947 6.27184L31.9739 9.57385L31.8112 9.27211L37.932 5.97009L38.0947 6.27184Z",
    fill: "#326A9D"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5705 44.4566C31.5705 44.8124 31.282 45.1008 30.9262 45.1008C30.5703 45.1008 30.2819 44.8124 30.2819 44.4566C30.2819 44.1007 30.5703 43.8123 30.9262 43.8123C31.282 43.8123 31.5705 44.1007 31.5705 44.4566Z",
    fill: "#18324B"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7716 20.1341C25.7716 20.7568 25.2668 21.2616 24.6441 21.2616C24.0214 21.2616 23.5166 20.7568 23.5166 20.1341C23.5166 19.5114 24.0214 19.0066 24.6441 19.0066C25.2668 19.0066 25.7716 19.5114 25.7716 20.1341Z",
    fill: "#2A5782"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5889 12.0237L34.6224 5.09755L34.962 5.05017L35.9284 11.9763L35.5889 12.0237Z",
    fill: "#2A5782"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1998 22.6576L35.8307 14.0401L36.1693 13.9863L37.5384 22.6038L37.1998 22.6576Z",
    fill: "#2A5782"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8076 12.7219L24.4183 8.45349L24.5486 8.13635L34.9379 12.4048L34.8076 12.7219Z",
    fill: "#4586D5"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5541 7.56275L15.1447 3.85805L15.298 3.55139L22.7074 7.25609L22.5541 7.56275Z",
    fill: "#4586D5"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1819 1.29375L18.5913 9.26691L18.2941 9.09584L22.8847 1.12268L23.1819 1.29375Z",
    fill: "#1E3A56"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9779 4.52039L15.3738 3.55394L15.3916 3.21155L33.9957 4.17799L33.9779 4.52039Z",
    fill: "#326A9D"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7205 18.3822L35.056 5.01312L35.3339 4.81226L44.9983 18.1814L44.7205 18.3822Z",
    fill: "#1A3B5A"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6677 6.69731L37.5402 21.9993L37.1982 21.9741L38.3258 6.67212L38.6677 6.69731Z",
    fill: "#326897"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2689 19.9679L39.5508 8.29006L39.8587 8.13928L45.5768 19.8171L45.2689 19.9679Z",
    fill: "#18324F"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0541 6.44995L39.8594 8.14123L39.5499 8.28863L38.7445 6.59736L39.0541 6.44995Z",
    fill: "#18324F"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7974 21.4996L22.3812 26.3319L22.0746 26.1785L24.4907 21.3463L24.7974 21.4996Z",
    fill: "#386CA5"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4755 22.5431L45.1869 19.8048L45.4971 19.6588L46.7857 22.3971L46.4755 22.5431Z",
    fill: "#15304B"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2369 23.2854L38.3443 23.6881L38.3268 23.3457L46.2194 22.943L46.2369 23.2854Z",
    fill: "#23354D"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.5818 23.8073L34.5013 34.2771L34.2767 34.018L46.3573 23.5482L46.5818 23.8073Z",
    fill: "#18324E"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8717 24.1415L43.8918 31.9536L43.5715 31.8314L46.5513 24.0193L46.8717 24.1415Z",
    fill: "#18324E"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.8832 31.7952L45.0912 19.6342L45.4324 19.668L44.2244 31.8291L43.8832 31.7952Z",
    fill: "#3B7BBB"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2788 32.3253L38.366 26.5267L38.6276 26.3051L43.5404 32.1037L43.2788 32.3253Z",
    fill: "#2E618E"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.682 26.4963L33.8967 33.6641L33.5936 33.504L37.3788 26.3362L37.682 26.4963Z",
    fill: "#4586D5"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9752 19.4547L38.6128 25.3339L38.3801 25.0821L44.7425 19.2029L44.9752 19.4547Z",
    fill: "#3B7BBB"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2282 18.7652C46.2282 19.1656 45.9036 19.4901 45.5033 19.4901C45.103 19.4901 44.7785 19.1656 44.7785 18.7652C44.7785 18.3649 45.103 18.0404 45.5033 18.0404C45.9036 18.0404 46.2282 18.3649 46.2282 18.7652Z",
    fill: "#417FC1"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8189 25.8521C38.8189 26.3414 38.4222 26.738 37.933 26.738C37.4437 26.738 37.0471 26.3414 37.0471 25.8521C37.0471 25.3628 37.4437 24.9662 37.933 24.9662C38.4222 24.9662 38.8189 25.3628 38.8189 25.8521Z",
    fill: "#76DBDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentellentLogo);
export default __webpack_public_path__ + "static/media/sentellent_logo.7ec4edf5c580aafaf15b4b3d9e081fda.svg";
export { ForwardRef as ReactComponent };